/* ═══════════════════════════════════════════════════════════════════════════
   CỬA GỬI DỮ LIỆU — chiến dịch bám đuổi 107 khách đã làm quiz mà chưa mua.

   ĐÂY LÀ CHỖ DUY NHẤT NỐI VỚI BACKEND. Trang khảo sát, popup chấm điểm và trang cảm ơn
   đều không tự gọi mạng — chúng chỉ gọi `MS107.gui(<tên sự kiện>, <dữ liệu>)`. Khi đội
   backend gửi tài liệu setup, sửa ĐÚNG MỘT HÀM `dayDiThat()` bên dưới là cả ba trang chạy.

   ĐÃ NỐI 17/09/2026 vào `POST /api/quiz/track` — cổng không có schema: gửi JSON gì cũng
   được, máy chủ lưu nguyên si, không parse, không có version phải bump. Tức là FE và MKT tự
   chốt danh sách sự kiện với nhau, đổi lúc nào cũng được mà backend không phải phát hành lại.
   Đánh đổi: KHÔNG ai kiểm hộ hình dạng dữ liệu. Đặt sai tên trường thì không lỗi nào báo,
   chỉ là về sau đọc bảng kết quả không thấy gì.

   ⚠️ GÓI GỬI ĐI CÓ ĐỊA CHỈ THƯ CỦA KHÁCH. Tài liệu API nói thẳng: cổng này không áp được
   luật dữ liệu cá nhân mà bảng `quiz_attempt_inputs` áp, nên "whoever sends must" — tức
   trách nhiệm nằm ở phía mình. Đừng thêm trường cá nhân nào khác vào đây mà chưa hỏi:
   ngày sinh, số điện thoại, địa chỉ nhà đều KHÔNG được gửi qua cổng này.

   SÁU TÊN SỰ KIỆN — khớp đúng sáu nhãn trong sơ đồ hành trình, đừng đặt tên khác:
     quiz_done · card_on_file · survey_done · gift_opened · feedback_done · upsell_clicked
   Sai một chữ là flow bên công cụ gửi thư rẽ nhầm nhánh, và nó hỏng im lặng: khách đã làm
   rồi vẫn bị nhắc làm lại.

   Thêm 21/09: `doc_opened` — khách mở BẢN NÀO trong hai bản (`doc: 'map' | 'report'`). Nó
   KHÔNG nằm trong sơ đồ hành trình và không có nhánh thư nào rẽ theo nó; chỉ để đo. Bắn ở
   `assets/pheu-107-luan-giai.js`.

   🗓️ Xoá cùng cả bộ `pheu-107-*` khi chiến dịch đóng.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── CÔNG TẮC ────────────────────────────────────────────────────────────────
     'chua-noi'  — chưa có backend. Lưu tạm vào máy khách, kêu to trong console, KHÔNG gọi mạng.
     'klaviyo'   — bắn sự kiện qua thư viện onsite của Klaviyo (window.klaviyo).
     'api'       — POST sang máy chủ riêng, địa chỉ khai ở `data-goc-gui` trên section.
     Đổi giá trị này khi có tài liệu setup, rồi điền nốt hàm tương ứng bên dưới. */
  var CUA = 'api';

  var KHOA_HANG = 'ms107_hang';       /* hàng đợi lưu tạm trên máy khách */
  var KHOA_PHIEN = 'ms_phien';        /* mã phiên, do layout/theme.liquid cất vào sessionStorage */
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  /* ── Mã phiên ────────────────────────────────────────────────────────────────
     Ba chỗ, theo đúng thứ tự tin cậy. Bộ nhớ phiên trước: đầu <head> của `layout/theme.liquid`
     đã cất mã từ mảnh neo vào đó rồi xoá mảnh neo để pixel không đọc được. Mảnh neo chỉ còn
     khi trình duyệt chặn lưu trữ. `localStorage` là chốt cuối cho khách đi từ chính quiz sang.

     Cùng một biểu thức đã siết như `layout/theme.liquid`: `[^&#?]` để không nuốt phải
     `?_kx=…` mà công cụ gửi thư chèn vào sau dấu `#`. */
  function phien() {
    var ma = '';
    try { ma = (sessionStorage.getItem(KHOA_PHIEN) || '').trim(); } catch (e) {}
    if (!ma) {
      try {
        var m = (window.location.hash || '').match(/[#&]s=([^&#?]+)/);
        if (m) ma = decodeURIComponent(m[1]).trim();
      } catch (e) {}
    }
    if (!ma) { try { ma = (localStorage.getItem('minespirit_phien') || '').trim(); } catch (e) {} }
    return UUID.test(ma) ? ma : '';
  }

  /* ── Địa chỉ thư ─────────────────────────────────────────────────────────────
     Ba chỗ theo thứ tự tin cậy, giống hệt lối của mã phiên: bộ nhớ phiên (đầu <head> đã cất
     từ mảnh neo rồi xoá mảnh neo), mảnh neo khi trình duyệt chặn lưu trữ, rồi `localStorage`.

     Kiểm định dạng trước khi trả: giá trị này đi thẳng vào thân request tới API, và nó đến
     từ thanh địa chỉ — tức chỗ người lạ gõ gì cũng được. */
  var THU = /^[^@\s]+@[^@\s.]+\.[^@\s]+$/;

  function email() {
    var e = '';
    try { e = (sessionStorage.getItem('ms107_email') || '').trim(); } catch (x) {}
    if (!e) {
      try {
        var m = (window.location.hash || '').match(/[#&]email=([^&#?]+)/);
        if (m) e = decodeURIComponent(m[1]).trim().toLowerCase();
      } catch (x) {}
    }
    if (!e) { try { e = (localStorage.getItem('ms107_email') || '').trim(); } catch (x) {} }
    return THU.test(e) ? e : '';
  }

  /* ── Hàng đợi ────────────────────────────────────────────────────────────────
     Lưu tạm để một lần gọi mạng hỏng không nuốt mất câu trả lời khách vừa gõ. Cắt 50 mục
     phòng khách mở đi mở lại: đây là bộ đệm, không phải kho.

     ⚠️ Đừng nhầm hàng đợi này là "đã thu được dữ liệu". Nó nằm trên MÁY KHÁCH, mình không
     đọc được. Chỉ khi `dayDiThat()` chạy thật thì câu trả lời mới về tới mình. */
  function docHang() {
    try { return JSON.parse(localStorage.getItem(KHOA_HANG) || '[]') || []; } catch (e) { return []; }
  }
  function ghiHang(ds) {
    try { localStorage.setItem(KHOA_HANG, JSON.stringify(ds.slice(-50))); } catch (e) {}
  }

  /* ── Nơi nối backend ─────────────────────────────────────────────────────────
     Trả về Promise. `true` = máy chủ đã nhận. `false` = chưa chắc — người gọi phải nói
     thật với khách, đừng hiện chữ "Saved" khi chưa gửi được.

     Vì sao không dùng `navigator.sendBeacon` cho mọi trường hợp: beacon không cho biết
     máy chủ có nhận hay không, mà ở đây câu trả lời của khách là thứ cả chiến dịch đi
     xin — không được phép mất im lặng. Chỉ dùng beacon cho sự kiện phụ (xem `bao()`). */
  /* Gốc API. Ô cài đặt để trống thì dùng mặc định — chiến dịch không được chết chỉ vì ai đó
     quên điền một ô. Cắt gạch chéo cuối cho khỏi thành `//api/...`. */
  function gocGui() {
    var e = document.querySelector('[data-goc-gui]');
    var v = e && (e.getAttribute('data-goc-gui') || '').trim();
    return (v || 'https://api.minespirit.com').replace(/\/+$/, '');
  }

  /* Trần 16 KB, đo trên THÂN THÔ trước khi parse (`413` nếu vượt). Câu trả lời mở cắt ở 2.000
     ký tự mỗi câu, mà một trang có thể tới 10 câu — tức có đường chạm trần thật. Cắt dần từ
     câu trả lời dài nhất xuống, giữ lại khung sự kiện, thay vì để cả gói bị máy chủ vứt. */
  var TRAN = 15000;
  function vuaTran(goi) {
    var chu = JSON.stringify(goi);
    if (chu.length <= TRAN) return goi;
    var ds = goi.data && goi.data.tra_loi;
    if (Array.isArray(ds)) {
      for (var n = 800; n >= 100 && chu.length > TRAN; n = Math.floor(n / 2)) {
        for (var i = 0; i < ds.length; i++) {
          if (typeof ds[i].tra_loi === 'string' && ds[i].tra_loi.length > n) {
            ds[i].tra_loi = ds[i].tra_loi.slice(0, n) + '…[cắt]';
          }
        }
        chu = JSON.stringify(goi);
      }
    }
    goi.truncated = chu.length > TRAN;
    return goi;
  }

  function dayDiThat(ten, goi) {
    if (CUA === 'api') {
      /* `text/plain` chứ KHÔNG phải `application/json`. Cả hai đều gửi đúng chuỗi JSON —
         tài liệu API nói rõ cổng này KHÔNG kiểm `content-type` — nhưng `application/json`
         là header không nằm trong danh sách an toàn của CORS, nên trình duyệt phải hỏi
         trước bằng một lượt `OPTIONS` rồi mới gửi thật. Dùng `text/plain` là lời gọi đơn
         giản: một lượt mạng thay vì hai, và không còn cửa nào cho preflight hỏng.
         Đây cũng chính là lý do `navigator.sendBeacon` ở `bao()` chạy được. */
      return fetch(gocGui() + '/api/quiz/track', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(vuaTran(goi))
      }).then(function (r) { return r.ok; });
    }
    if (CUA === 'klaviyo') {
      /* TODO khi có tài liệu setup:
           return window.klaviyo.push(['track', ten, goi]);
         Nhớ kiểm `window.klaviyo` có mặt thật — trình chặn quảng cáo nuốt `klaviyo.js`
         rất thường, và lúc đó lời gọi này hỏng KHÔNG BÁO GÌ.
         Và nhớ: `snippets/brand-tat-popup-mail.liquid` ẩn mọi `[class*='klaviyo-form']`
         trên trang phễu, nên KHÔNG dựng biểu mẫu bằng Klaviyo Form — nó sẽ tàng hình. */
      return Promise.resolve(false);
    }
    if (CUA === 'api') {
      /* TODO khi có tài liệu setup: điền đường dẫn thật rồi bỏ dòng `resolve(false)`.
           var goc = (document.querySelector('[data-goc-gui]') || {}).dataset;
           return fetch(goc.gocGui + '/…', { method: 'POST', … }).then(r => r.ok); */
      return Promise.resolve(false);
    }
    return Promise.resolve(false);   /* 'chua-noi' */
  }

  /* ── Hàm công khai ───────────────────────────────────────────────────────────
     Luôn lưu tạm TRƯỚC khi gọi mạng: gọi mạng hỏng giữa chừng thì câu chữ vẫn còn. */
  function gui(ten, duLieu) {
    /* Khoá `event` đặt theo đúng ví dụ trong tài liệu API; mấy khoá còn lại là quy ước giữa
       FE và MKT, đổi được bất cứ lúc nào. `campaign` để lọc nhanh sự kiện của chiến dịch này
       ra khỏi cả kho — cổng này dùng chung, không có gì tự phân loại hộ. */
    var goi = {
      event: ten,
      campaign: 'pheu-107',
      at: new Date().toISOString(),
      /* PHẢI có `email`. Chiến dịch này nhận diện khách bằng ĐỊA CHỈ THƯ, nên link trong thư
         mang `#email=` chứ không mang `#s=` — tức `session` gần như luôn `null`. Thiếu dòng
         này thì mọi bản ghi về tới máy chủ đều VÔ DANH: có câu trả lời mà không biết của ai,
         và cả chiến dịch mất đúng thứ nó đi xin. Không lỗi nào báo.
         Giữ luôn `session` cho ca khách đi từ chính quiz sang — lúc đó có mã phiên thật. */
      email: email() || null,
      session: phien() || null,
      path: (window.location && window.location.pathname) || '',
      data: duLieu || {}
    };

    var ds = docHang();
    ds.push(goi);
    ghiHang(ds);

    if (CUA === 'chua-noi') {
      /* Kêu to, và kêu mỗi lần. Đây là trạng thái dễ quên nhất của cả chiến dịch: trang
         chạy mượt, khách bấm thấy chuyển màn bình thường, mà không một chữ nào về tới mình. */
      try {
        console.warn('[MS107] CHƯA NỐI BACKEND — sự kiện "' + ten + '" chỉ nằm trên máy khách, '
                   + 'KHÔNG gửi đi đâu cả. Sửa biến CUA trong assets/pheu-107-gui.js.', goi);
      } catch (e) {}
      return Promise.resolve(false);
    }

    return dayDiThat(ten, goi)['catch'](function () { return false; });
  }

  /* Sự kiện phụ — chỉ để biết khách có tới nơi không, mất một cái không sao. Không chờ
     kết quả, không chặn điều hướng. */
  /* Sự kiện phụ — bắn rồi đi, không chờ. Dùng `sendBeacon` vì nó SỐNG SÓT qua điều hướng,
     còn `fetch` thường bị trình duyệt huỷ khi rời trang. Tài liệu API nói rõ cổng này không
     kiểm `content-type`, nên beacon không biến lời gọi thành request preflight của CORS.
     Không có beacon (trình duyệt cũ) thì rơi về `gui()` như thường. */
  function bao(ten, duLieu) {
    try {
      if (CUA === 'api' && navigator.sendBeacon) {
        var goi = vuaTran({
          event: ten, campaign: 'pheu-107', at: new Date().toISOString(),
          email: email() || null, session: phien() || null,
          path: (window.location && window.location.pathname) || '', data: duLieu || {}
        });
        var ds = docHang(); ds.push(goi); ghiHang(ds);
        navigator.sendBeacon(gocGui() + '/api/quiz/track', JSON.stringify(goi));
        return;
      }
      gui(ten, duLieu);
    } catch (e) {}
  }


  /* ═══════════════════════════════════════════════════════════════════════════
     CÂU HỎI — đọc và gom. Dùng chung cho trang khảo sát và hộp góp ý.

     Markup do `snippets/pheu-107-cau-hoi.liquid` dựng. Hai bên tìm nhau qua các dấu
     `data-q7*`; đổi tên dấu ở một bên mà quên bên kia thì câu trả lời rơi IM LẶNG —
     biểu mẫu vẫn gửi, chỉ là gửi đi một mảng rỗng.
     ═══════════════════════════════════════════════════════════════════════════ */

  /* Chữ của câu hỏi, đã bỏ nhãn "optional". Gửi kèm chữ gốc chứ không chỉ mã khối: mã khối
     là chuỗi ngẫu nhiên của Shopify, người đọc bảng kết quả sẽ thấy `block_abc123 = "The
     price"` mà không biết đó là câu gì. Và khi người kinh doanh sửa lại câu hỏi giữa chiến
     dịch, chỉ bản ghi mang chữ gốc mới nói được câu trả lời ứng với câu hỏi nào. */
  function chuHoi(cau) {
    var l = cau.querySelector('.q7__hoi');
    if (!l) return '';
    var ban = l.cloneNode(true);
    var phu = ban.querySelector('.q7__tuy-y');
    if (phu) phu.parentNode.removeChild(phu);
    return (ban.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* Luôn trả về CHUỖI, kể cả câu chọn nhiều — lúc đó các đáp án nối bằng " | ". Giữ một kiểu
     dữ liệu duy nhất để bảng kết quả đọc được bằng mắt và người dựng backend không phải viết
     hai nhánh. Dòng "ý khác" được thay bằng chữ khách tự viết, không phải bằng mã `__khac__`. */
  function chuOKhac(cau) {
    var o = cau.querySelector('[data-q7-o-khac]');
    return (o && o.value || '').trim();
  }

  function dapAn(cau) {
    if (cau.hasAttribute('data-nhieu')) {
      var ds = cau.querySelectorAll('input[type="checkbox"][data-q7-o]:checked');
      var ra = [];
      for (var i = 0; i < ds.length; i++) {
        if (ds[i].hasAttribute('data-q7-khac')) {
          var tuViet = chuOKhac(cau);
          if (tuViet) ra.push(tuViet);
          /* Tick "ý khác" mà bỏ trống ô chữ thì KHÔNG đẩy mã `__khac__` sang máy chủ — đó là
             chữ nội bộ, đọc trong bảng kết quả ra một dòng vô nghĩa. Coi như chưa chọn. */
        } else {
          ra.push(ds[i].value);
        }
      }
      return ra.join(' | ');
    }

    var chonKhac = cau.querySelector('[data-q7-khac]:checked');
    if (chonKhac) return chuOKhac(cau);

    var radio = cau.querySelector('input[type="radio"][data-q7-o]:checked');
    if (radio) return radio.value;
    var mo = cau.querySelector('textarea[data-q7-o]');
    if (mo) return (mo.value || '').trim();
    return '';
  }

  /* Trả về: danh sách câu trả lời · danh sách câu bắt buộc còn trống · điểm của câu thang
     đầu tiên (0 nếu không có). Điểm tách riêng vì trang luận giải rẽ nhánh theo nó. */
  function gomCauHoi(goc) {
    var ds = goc.querySelectorAll('[data-q7]');
    var ra = [], thieu = [], diem = 0;
    for (var i = 0; i < ds.length; i++) {
      var cau = ds[i];
      var tl = dapAn(cau).slice(0, 2000);
      if (!tl && cau.hasAttribute('data-bat-buoc')) thieu.push(cau);
      if (!diem && cau.getAttribute('data-loai') === 'cau_diem') {
        var n = parseInt(tl, 10);
        if (n >= 1 && n <= 5) diem = n;
      }
      ra.push({ ma: cau.getAttribute('data-ma') || '', hoi: chuHoi(cau), tra_loi: tl });
    }
    return { tra_loi: ra, thieu: thieu, diem: diem };
  }

  /* Nối hành vi cho mọi câu hỏi trong một khung: mở ô "ý khác", và dọn lời trách ngay khi
     khách vừa sửa. Để lời trách treo lại sau khi người ta đã trả lời là trách oan. */
  function noiCauHoi(goc) {
    var ds = goc.querySelectorAll('[data-q7]');
    for (var i = 0; i < ds.length; i++) {
      (function (cau) {
        var oKhac = cau.querySelector('[data-q7-o-khac]');
        function don() {
          cau.removeAttribute('data-sai');
          var l = cau.querySelector('[data-q7-loi]');
          if (l) l.setAttribute('hidden', '');
        }
        /* ── Hạn mức của câu chọn nhiều ───────────────────────────────────────
           Đủ số thì KHOÁ những ô chưa tick, không khoá ô đã tick — khách vẫn phải bỏ được
           lựa chọn cũ để đổi ý. Khoá bằng `disabled` để ô xám đi tự giải thích; chặn cú bấm
           mà không đổi gì thì khách tưởng trang hỏng. */
        function canhHanMuc() {
          if (!cau.hasAttribute('data-nhieu')) return;
          var toiDa = parseInt(cau.getAttribute('data-so-toi-da'), 10) || 0;
          if (!toiDa) return;
          var ds = cau.querySelectorAll('input[type="checkbox"][data-q7-o]');
          var dem = cau.querySelectorAll('input[type="checkbox"][data-q7-o]:checked').length;
          for (var k = 0; k < ds.length; k++) ds[k].disabled = (dem >= toiDa && !ds[k].checked);
          cau.toggleAttribute('data-day', dem >= toiDa);
        }
        canhHanMuc();

        cau.addEventListener('change', function () {
          don();
          canhHanMuc();
          if (!oKhac) return;
          if (cau.querySelector('[data-q7-khac]:checked')) {
            oKhac.removeAttribute('hidden');
            try { oKhac.focus(); } catch (e) {}
          } else {
            oKhac.setAttribute('hidden', '');
          }
        });
        cau.addEventListener('input', don);
      })(ds[i]);
    }
  }

  /* Đánh dấu những câu bắt buộc còn trống, rồi kéo câu đầu tiên vào tầm mắt. */
  function baoThieu(thieu, chu) {
    for (var i = 0; i < thieu.length; i++) {
      thieu[i].setAttribute('data-sai', '');
      var l = thieu[i].querySelector('[data-q7-loi]');
      if (l) { l.textContent = chu; l.removeAttribute('hidden'); }
    }
    if (thieu.length) {
      try { thieu[0].scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    }
  }

  window.MS107 = {
    phien: phien,
    email: email,
    gui: gui,
    bao: bao,
    hang: docHang,
    gomCauHoi: gomCauHoi,
    noiCauHoi: noiCauHoi,
    baoThieu: baoThieu,
    daNoi: function () { return CUA !== 'chua-noi'; },
    cua: function () { return CUA; }
  };

  /* Dán cờ lên <html> để soi bằng mắt lúc kiểm: chưa nối thì thấy ngay trong DevTools
     mà không phải mở console. */
  try {
    if (CUA === 'chua-noi') document.documentElement.setAttribute('data-ms107-chua-noi', '');
  } catch (e) {}
})();
